import type { Messages } from "next-intl";
import { createContext } from "react";

export const MessagesContext = createContext<Partial<Messages>>({});
